<template>
  <div class="w-8/12"></div>
  <!-- <div class="w-3/12 flex justify-center">
    <InlineSvg :src="IrisLogoStandart" width="100" height="40" />
  </div> -->
  <div class="w-4/12 flex justify-end">
    <BackAdvisor />
    <Help />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import BackAdvisor from './BackAdvisor.vue'

import IrisLogoStandart from '@/assets/svg/iris-logo-standard.svg'
import Help from '@/components/Header/Help.vue'

export default {
  name: 'ClientPreviewHeader',
  components: {
    BackAdvisor,
    Help,
  },
  setup() {
    const route = useRoute()

    const isShowLogo = computed(() => {
      return route.name !== 'lead/dashboard'
    })

    return {
      isShowLogo,
      IrisLogoStandart,
    }
  },
}
</script>
